import { createContext } from 'react';
import type { GoogleSignInResponse } from 'src/services/signInWithGoogle';

export interface AuthContextValue {
  user: Record<string, unknown> | null;
  setUser: (user: Record<string, unknown> | null) => void;
  signInWithGoogleFunc: (code: string) => Promise<GoogleSignInResponse | Error>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
